import { Text, TextProps } from '@chakra-ui/react'

export interface ICharCountProps extends Omit<TextProps, 'children'> {
  value: string | null | undefined
  /** O mesmo número do `maxLength` do controle — que deve ser o mesmo `max` da validação da API. */
  max: number
}

/** A partir desta fração do limite o contador fica laranja, para avisar antes de travar. */
const WARNING_RATIO = 0.9

/**
 * Contador `n/máx` de um campo de texto com limite, alinhado à direita logo abaixo do controle.
 *
 * Vai como filho do `FormField`, depois do controle, e não no `helperText`: o `helperText` some
 * quando o campo está em erro, que é justamente quando o limite importa.
 */
export default function CharCount({ value, max, ...rest }: ICharCountProps) {
  const count = value?.length ?? 0
  const color = count >= max ? 'red.500' : count >= max * WARNING_RATIO ? 'orange.500' : 'gray.500'

  return (
    <Text fontSize="xs" color={color} textAlign="right" mt={1} {...rest}>
      {count}/{max}
    </Text>
  )
}
